/**
 * contactForm.js — Formularios de consulta ([data-contact-form]).
 *
 * Validación en cliente (requeridos + e-mail), envío por fetch a
 * api/contact.php y feedback en el DOM (#<id>-result). El endpoint reenvía
 * al relay Submit 1.0; la API key no viaja en este módulo. Los textos
 * llegan traducidos en data-messages (inc/components/contact-form.php).
 * Sin alert()/innerHTML: todo con textContent.
 *
 * @see docs/specs/dvb-forms-map.md
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

/**
 * @param {HTMLFormElement} form
 * @param {Record<string,string>} msg
 * @returns {boolean}
 */
function validate (form, msg) {
  let valid = true
  form.querySelectorAll('input[name], textarea[name]').forEach((field) => {
    if (field.type === 'hidden' || field.name === 'website') return
    const box = field.closest('.form-field')
    const error = box?.querySelector('.form-error')
    const value = field.value.trim()
    let text = ''

    if (field.required && value === '') text = msg.required
    else if (field.type === 'email' && value !== '' && !EMAIL_RE.test(value)) text = msg.email

    field.setAttribute('aria-invalid', text ? 'true' : 'false')
    if (error) error.textContent = text
    if (text) valid = false
  })
  return valid
}

/**
 * @param {HTMLElement} result
 * @param {string} text
 * @param {boolean} isError
 */
function showResult (result, text, isError) {
  if (!result) return
  result.textContent = text
  result.classList.toggle('is-error', isError)
  result.hidden = false
}

function contactForm () {
  document.querySelectorAll('[data-contact-form]').forEach((form) => {
    let msg = {}
    try { msg = JSON.parse(form.dataset.messages || '{}') } catch (err) { msg = {} }

    const result = form.querySelector('.form-result')
    const button = form.querySelector('[type="submit"]')

    // Limpia el error de un campo en cuanto se corrige.
    form.addEventListener('input', (e) => {
      const field = e.target
      if (field.getAttribute('aria-invalid') === 'true') {
        field.setAttribute('aria-invalid', 'false')
        const error = field.closest('.form-field')?.querySelector('.form-error')
        if (error) error.textContent = ''
      }
    })

    form.addEventListener('submit', async (e) => {
      e.preventDefault()
      if (result) result.hidden = true

      if (!validate(form, msg)) {
        showResult(result, msg.invalid, true)
        form.querySelector('[aria-invalid="true"]')?.focus()
        return
      }

      form.classList.add('is-sending')
      button.disabled = true

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
        const data = await response.json().catch(() => ({}))

        if (response.ok && data.ok) {
          form.reset()
          showResult(result, msg.success, false)
        } else {
          showResult(result, data.message || msg.error, true)
        }
      } catch (err) {
        showResult(result, msg.error, true)
      } finally {
        form.classList.remove('is-sending')
        button.disabled = false
      }
    })
  })
}

export default contactForm
